import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDatepicker, MatDialogRef} from '@angular/material';
import {ResearchListItem} from '../../entity/research-list-item';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Research} from '../../entity/research';

@Component({
  selector: 'app-research-details-dialog',
  templateUrl: './research-details-dialog.component.html',
  styleUrls: ['./research-details-dialog.component.css']
})
export class ResearchDetailsDialogComponent implements OnInit, AfterViewInit {

//   public clients = [
//     'МЦ Ескулаб',
//     'МЦ Оксфорд-медікал'
//   ];
//
//   public practitioners = [
//     'Лукавецький І.В.',
//     'Солига Г.М',
//     'Федорко О. Ю.'
//   ];
//
//   public sexOptions = [
//     '',
//     'MALE',
//     'FEMALE'
//   ];
//
//   public diagnoses = [
//     'лімфома? л/вузол шиї справа.',
//     'вірусна бородавка губи та слизової рота.',
//     'Са ЛГЗ',
//     'дисплазія ш/матки.'
//   ];
//
//   public conclusions = [
//     'Mammaglobin(Clone304-1A5)',
//     'Desmin Ab-1(CloneD33)',
//     'GCDFP-15 (gross cystic disease fluid protein-15)Ab-1(Clone23A3)',
//     '++Помірно-позитивна реакція',
//     'Імунофенотип пухлини відповідає негоджкінській дифузній В-клітинній лімфомі з малих клітин, не виключено хронічному лімфолейкозу.',
//     'Імунофенотип пухлини відповідає нейроендокринній великоклітинній карциномі G3.'
// ];
//
//   public filteredClients: Observable<string[]>;
//   public filteredPractitioners: Observable<string[]>;
//   public filteredDiagnoses: Observable<string[]>;
//   public filteredConclusions: Observable<string[]>;
//
//   public researchDate: Date;
//   public clientTitle: string;
//
//   // @ts-ignore
//   @ViewChild(MatDatepicker) datepicker: MatDatepicker<Date>;
//
//   clientsControl = new FormControl();
//   practitionersControl = new FormControl();
//   diagnosisControl = new FormControl();
//   conclusionControl = new FormControl();

  constructor(public dialogRef: MatDialogRef<ResearchDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) public research: Research) {}

  ngOnInit(): void {
    // this.filteredClients = this.clientsControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filterClients(value))
    //   );
    //
    // this.filteredPractitioners = this.practitionersControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filterPractitioners(value))
    //   );
    //
    // this.filteredDiagnoses = this.diagnosisControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filterDiagnoses(value))
    //   );
    //
    // this.filteredConclusions = this.conclusionControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filterConclusions(value))
    //   );
  }

  ngAfterViewInit() {
    // this.clientsControl.setValue(this.research.clientTitle);
  }
  //
  // private _filterClients(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //
  //   return this.clients.filter(option => option.toLowerCase().includes(filterValue));
  // }
  //
  // private _filterPractitioners(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //
  //   return this.practitioners.filter(option => option.toLowerCase().includes(filterValue));
  // }
  //
  // private _filterDiagnoses(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //
  //   return this.diagnoses.filter(option => option.toLowerCase().includes(filterValue));
  // }
  //
  // private _filterConclusions(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //
  //   return this.conclusions.filter(option => option.toLowerCase().includes(filterValue));
  // }

  save() {
    console.log('Research', this.research);
    this.dialogRef.close(this.research);
  }

  onNoClick(): void {
    console.log('On no click');
    // this.dialogRef.close();
  }

}
